{
  "pt": {
    "editor_ziggu": {
      "actions": {
        "apply": "Aplicar",
        "cancel": "Cancelar",
        "link": "Ligação",
        "showLess": "Mostrar menos",
        "showMore": "Mostrar mais"
      },
      "labels": {
        "blue": "Azul",
        "green": "Verde",
        "link_text": "Texto da ligação",
        "orange": "Laranja",
        "pink": "Cor-de-rosa",
        "purple": "Púrpura",
        "red": "Vermelho",
        "remove_highlight": "Remover destaque",
        "yellow": "Amarelo"
      },
      "placeholders": {
        "content": "Começar a escrever...",
        "link": "Escrever/colar uma ligação"
      }
    }
  }
}